








































import {Emit, Prop} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component, Vue} from '@/shared/component';

import {Client} from '@/models';

import CrudClientEditPrixClient from '@/components/Crud/Client/EditPrixClient.vue';

@Component({
	components: {
		CrudClientEditPrixClient,
	}
})
export default class CrudClientEditDialogReglement extends Vue {
	@InOut({ type: Client  , isVModel: true }) private value!: Client;

	@Emit()
	private onSubmit(client: Client) {
		this.onClose();
	}

	@Emit()
	private onClose() {
		this.value = null;
	}
}
